/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconAxe: {
  name: 'axe';
  data: string;
} = {
  name: 'axe',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m263.25 418.188 158.458-158.457-8.443-8.443 35.927-35.926-52.219-52.219-.001-.002-35.927 35.927-8.444-8.444-6.537 6.537c-22.681-45.012-18.441-99.956 22.169-169.344l-.001-.002C170.876-51.42-41.994 188.944 26.284 377.396c63.956-37.181 129.911-53.047 179.141-39.597l-11.282 11.282 8.444 8.444L12.839 547.272v54.366h50.075l191.893-191.893 8.443 8.443zM585.759 245.343c-70.356 41.175-125.765 45.096-171.059 21.396L275.275 406.164c14.457 49.414-1.378 116.245-39.097 181.127 188.451 68.277 428.816-144.593 349.581-341.948z"/></svg>`,
};
